import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'
import type { TAdminListParams } from '@/core/lib/table-query'

import { teamTagEndpoints } from '@/modules/team-tag/team-tag.constants'
import type {
  TCreateTeamTagRequest,
  TTeamTag,
  TUpdateTeamTagRequest,
} from '@/modules/team-tag/team-tag.types'

export async function listTeamTags(
  params: TAdminListParams
): Promise<TResponse<TTeamTag[]>> {
  const response = await api.get<TResponse<TTeamTag[]>>(
    teamTagEndpoints.list(params)
  )
  return response.data
}

export async function listTeamTagOptions(): Promise<TTeamTag[]> {
  const response = await api.get<TResponse<TTeamTag[]>>(
    teamTagEndpoints.options
  )
  return response.data.data
}

export async function createTeamTag(
  payload: TCreateTeamTagRequest
): Promise<TTeamTag> {
  const response = await api.post<TResponse<TTeamTag>>(
    teamTagEndpoints.create,
    payload
  )
  return response.data.data
}

export async function updateTeamTag(
  id: string,
  payload: TUpdateTeamTagRequest
): Promise<TTeamTag> {
  const response = await api.patch<TResponse<TTeamTag>>(
    teamTagEndpoints.update(id),
    payload
  )
  return response.data.data
}

export async function deleteTeamTag(id: string): Promise<void> {
  await api.delete(teamTagEndpoints.delete(id))
}

export async function getTeamTags(teamId: string): Promise<TTeamTag[]> {
  const response = await api.get<TResponse<TTeamTag[]>>(
    teamTagEndpoints.teamTags(teamId)
  )
  return response.data.data
}

export async function assignTeamTags(
  teamId: string,
  tagIds: string[]
): Promise<TTeamTag[]> {
  const response = await api.patch<TResponse<TTeamTag[]>>(
    teamTagEndpoints.teamTags(teamId),
    { tag_ids: tagIds }
  )
  return response.data.data
}
